/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class IspReportsAPI extends ApiClient {
  constructor() {
    super('isp_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  // GK-HUB: Motivos report with teamId + status params
  getMotivos({ from, to, inboxId, agentId, teamId, status } = {}) {
    return axios.get(`${this.url}/motivos`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
        agent_id: agentId,
        team_id: teamId,
        status,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: FCR report with team filter
  getFcr({ from, to, inboxId, agentId, motivo, teamId } = {}) {
    return axios.get(`${this.url}/fcr`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
        agent_id: agentId,
        motivo,
        team_id: teamId,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: Recorrencia report with pagination (teamId)
  getRecorrencia({
    from,
    to,
    inboxId,
    motivo,
    minContacts,
    teamId,
    page,
  } = {}) {
    return axios.get(`${this.url}/recorrencia`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
        motivo,
        min_contacts: minContacts,
        team_id: teamId,
        page,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: Recorrencia detail (contact conversations)
  getRecorrenciaDetail(contactId, { from, to, teamId } = {}) {
    return axios.get(`${this.url}/recorrencia_detail`, {
      params: {
        contact_id: contactId,
        since: from,
        until: to,
        team_id: teamId,
        timezone_offset: getTimeOffset(),
      },
    });
  }
  // GK-HUB: end recorrencia

  getMotivosList() {
    return axios.get(`${this.url}/motivos_list`);
  }

  getPainel({ from, to, teamId } = {}) {
    return axios.get(`${this.url}/painel`, {
      params: {
        since: from,
        until: to,
        team_id: teamId,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: Agent ranking report (team_id filter)
  getAgentRanking({ from, to, teamId } = {}) {
    return axios.get(`${this.url}/agent_ranking`, {
      params: {
        since: from,
        until: to,
        team_id: teamId,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: Agent detail report (per-agent consolidated data for slide-over modal)
  getAgentDetail({ agentId, from, to, teamId } = {}) {
    return axios.get(`${this.url}/agent_detail`, {
      params: {
        agent_id: agentId,
        since: from,
        until: to,
        team_id: teamId,
        timezone_offset: getTimeOffset(),
      },
    });
  }
  // GK-HUB: end agent detail

  // GK-HUB: Queue metrics historical report
  getQueueMetrics({ from, to, teamId } = {}) {
    return axios.get(`${this.url}/queue_metrics`, {
      params: {
        since: from,
        until: to,
        team_id: teamId,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: Conversations report (paginated list + summary)
  getConversas({
    from,
    to,
    inboxId,
    agentId,
    teamId,
    motivo,
    status,
    iaFilter,
    channelType,
    search,
    page,
    dateField,
  } = {}) {
    return axios.get(`${this.url}/conversas`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
        agent_id: agentId,
        team_id: teamId,
        motivo,
        status,
        ia_filter: iaFilter,
        channel_type: channelType,
        search,
        page,
        date_field: dateField, // GK-HUB: 'resolved_at' filtra por updated_at (#27)
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: CSAT ISP report (satisfaction, distribution, evolution, per-agent, feedbacks)
  getCsat({ from, to, agentId, teamId, rating, page } = {}) {
    return axios.get(`${this.url}/csat`, {
      params: {
        since: from,
        until: to,
        agent_id: agentId,
        team_id: teamId,
        rating,
        page,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // GK-HUB: CSAT drill-down — paginated list of responses for an agent/inbox
  getCsatResponses({ from, to, agentId, inboxId, teamId, rating, page } = {}) {
    return axios.get(`${this.url}/csat_responses`, {
      params: {
        since: from,
        until: to,
        agent_id: agentId,
        inbox_id: inboxId,
        team_id: teamId,
        rating,
        page,
        timezone_offset: getTimeOffset(),
      },
    });
  }
  // GK-HUB: end csat

  // GK-HUB: Campaign analytics report (KPIs, evolution, errors, teams, table)
  getCampanhas({ from, to, teamId } = {}) {
    return axios.get(`${this.url}/campanhas`, {
      params: {
        since: from,
        until: to,
        team_id: teamId,
        timezone_offset: getTimeOffset(),
      },
    });
  }
  // GK-HUB: end campanhas

  // GK-HUB: Conversation detail with messages timeline
  getConversasDetail(conversationId) {
    return axios.get(`${this.url}/conversas_detail`, {
      params: { conversation_id: conversationId },
    });
  }
  // GK-HUB: end conversas
}

export default new IspReportsAPI();
